import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

export const claim = {
  namespaced: true,
  state: {
    claims: null,
    claim: {}
  },
  actions,
  getters,
  mutations
};
